export class FrontofficeExportFileLogic {
  /**
   * Mostra il pulsante di esportazione per il frontoffice
   */
  static get showExportCsvButton(): boolean {
    return process.env.ENABLE_CSV_EXPORT_FRONTOFFICE === 'true';
  }
  /**
   * Mostro il pulsante di esportazione Geojson per il frontoffice
   */
  static get showExportGeojsonButton(): boolean {
    return process.env.ENABLE_GEOJSON_EXPORT_FRONTOFFICE === 'true';
  }
}
